/* upsell.js */
(function () {
  'use strict';

  // =========================================================================
  // String utils (pulizia & normalizzazione)
  // =========================================================================
  function stripMeta(s) {
    // Rimuove suffissi tipo "– sold out", parentesi, separatori vari, compattazione spazi
    s = String(s || '');
    s = s.split(' – ')[0].split(' - ')[0].split(' — ')[0];
    s = s.replace(/\(.*?\)/g, '');
    s = s.replace(/[\/|]+/g, ' ').replace(/[-–—]+/g, ' ');
    s = s.replace(/\s+/g, ' ').trim();
    return s;
  }

  function clean(s) {
    s = stripMeta(s);
    s = (s == null ? '' : String(s))
      .replace(/(^["']+|["'\n\r]+$)/g, '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    s = s.replace(/[^a-z0-9\s]/g, '');
    return s.replace(/\s+/g, ' ').trim();
  }

  // Match "robusto": equality / startsWith / includes (bidirezionale)
  function softMatch(a, b) {
    a = clean(a);
    b = clean(b);
    if (!a || !b) return false;
    return a === b || a.startsWith(b) || b.startsWith(a) || a.includes(b) || b.includes(a);
  }

  // =========================================================================
  // Mappa colori IT -> EN (caricata da asset color-map.json)
  // =========================================================================
  var COLOR_MAP = null;

  async function loadColorMap() {
    if (COLOR_MAP) return COLOR_MAP;
    try {
      var url = window.COLOR_MAP_URL || '/assets/color-map.json';
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var json = await res.json();

      COLOR_MAP = {};
      Object.keys(json || {}).forEach(function (k) {
        var v = json[k];
        COLOR_MAP[clean(k)] = clean(v);
      });
    } catch (e) {
      console.warn('[UPSELL] Impossibile caricare color-map.json:', e);
      COLOR_MAP = {}; // non bloccare il flusso
    }
    return COLOR_MAP;
  }

  // Converte un colore localizzato → canonico (inglese) con priorità alla mappa.
  // rawVisible: quello che l’utente vede
  // rawOriginalAttr: eventuale data-original-title (fallback)
  function localToCanonical(rawVisible, rawOriginalAttr, colorMap) {
    var vis = clean(rawVisible);
    if (colorMap && colorMap[vis]) return colorMap[vis]; // 1) mappa su visibile

    var orig = clean(rawOriginalAttr || '');
    if (colorMap && colorMap[orig]) return colorMap[orig]; // 2) mappa su originale

    if (orig) return orig; // 3) usa originale pulito
    return vis;            // 4) fallback: visibile pulito
  }

  // =========================================================================
  // Refresh del drawer
  // =========================================================================
  function refreshCartDrawer() {
    try {
      if (window.theme && window.theme.CartDrawer && typeof window.theme.CartDrawer.open === 'function') {
        window.theme.CartDrawer.open();
        return;
      }
    } catch (e) {
      console.warn('[UPSELL] theme.CartDrawer non disponibile:', e);
    }

    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newBody = doc.querySelector('[data-cart-dynamic-content="cart-body"]');
        var newFooter = doc.querySelector('[data-cart-dynamic-content="cart-footer"]');

        var targetBody = document.querySelector('[data-cart-dynamic-content="cart-body"]');
        var targetFooter = document.querySelector('[data-cart-dynamic-content="cart-footer"]');

        if (newBody && targetBody) targetBody.innerHTML = newBody.innerHTML;
        if (newFooter && targetFooter) targetFooter.innerHTML = newFooter.innerHTML;
      })
      .catch(function (err) {
        console.error('[UPSELL] Errore refreshCartDrawer:', err);
      });
  }

  // =========================================================================
  // Lettura selezione dal <select> varianti upsell
  // =========================================================================
  function getSelectedOption(selectEl) {
    if (!selectEl) return { text: '', dataOriginal: '' };
    var opt =
      (selectEl.selectedOptions && selectEl.selectedOptions[0]) ||
      selectEl.options[selectEl.selectedIndex];
    if (!opt) return { text: '', dataOriginal: '' };

    return {
      text: opt.text || opt.value || '',
      dataOriginal: (opt.dataset && opt.dataset.originalTitle) ? opt.dataset.originalTitle : ''
    };
  }

  // =========================================================================
  // Lookup variante bundle con mappa colori e matching robusto
  // =========================================================================
  async function getBundleVariantId(bundleHandle, mainColorRaw, upsellColorRaw, mainColorOriginalRaw, upsellOriginalRaw) {
    var rootUrl = (window.routes && window.routes.root_url) ? window.routes.root_url : '';
    var normalizedRoot = rootUrl && rootUrl !== '/' ? rootUrl.replace(/\/$/, '') : '';
    var productUrl = normalizedRoot + '/products/' + bundleHandle + '.js';
    var res = await fetch(productUrl, { credentials: 'same-origin' });
    if (!res.ok) {
      var debugInfo = {
        bundleHandle: bundleHandle,
        productUrl: productUrl,
        status: res.status,
        statusText: res.statusText,
        origin: window.location.origin,
        pathname: window.location.pathname,
        rootUrl: rootUrl
      };
      try {
        debugInfo.responseText = (await res.text()).slice(0, 300);
      } catch (e) {
        debugInfo.responseText = '[unreadable response]';
      }
      console.error('[UPSELL] Bundle fetch failed', debugInfo);
      throw new Error('Bundle prodotto non trovato: ' + bundleHandle);
    }
    var product = await res.json();

    if (product && product.variants && product.variants.length === 1) {
      return product.variants[0].id;
    }

    var map = await loadColorMap();

    // 1) Canonici (sempre)
    var mainColor = localToCanonical(mainColorRaw, mainColorOriginalRaw, map);
    var upsellColor = localToCanonical(upsellColorRaw, upsellOriginalRaw, map);

    var mainC = clean(mainColor);
    var upsellC = clean(upsellColor);

    // 2) Tentativo #1: match su option1/option2 (robusto + swap)
    var variant = (product.variants || []).find(function (v) {
      var o1 = clean(v.option1);
      var o2 = clean(v.option2);

      // Se bundle a una sola opzione
      if ((product.options || []).length <= 1) {
        return softMatch(o1, mainC) || softMatch(o1, upsellC);
      }

      // Due opzioni: prova diretto + swap
      return (
        (softMatch(o1, mainC) && softMatch(o2, upsellC)) ||
        (softMatch(o1, upsellC) && softMatch(o2, mainC))
      );
    });

    // 3) Tentativo #2: match sul titolo variante (alcuni bundle compongono i colori nel title)
    if (!variant) {
      variant = (product.variants || []).find(function (v) {
        var t = clean(v.title);
        return t.includes(mainC) && t.includes(upsellC);
      });
    }

    // 4) Tentativo #3: “contains” più permissivo su option1/option2 e title
    if (!variant) {
      variant = (product.variants || []).find(function (v) {
        var o1 = clean(v.option1);
        var o2 = clean(v.option2);
        var t = clean(v.title);

        var hitO =
          (o1 && (o1.includes(mainC) || mainC.includes(o1) || o1.includes(upsellC) || upsellC.includes(o1))) ||
          (o2 && (o2.includes(mainC) || mainC.includes(o2) || o2.includes(upsellC) || upsellC.includes(o2)));

        var hitT = t && t.includes(mainC) && t.includes(upsellC);

        if ((product.options || []).length <= 1) return hitO || hitT;

        // se 2 opzioni, richiedi comunque entrambi i colori da qualche parte
        var hasMain = (o1.includes(mainC) || o2.includes(mainC) || t.includes(mainC));
        var hasUpsell = (o1.includes(upsellC) || o2.includes(upsellC) || t.includes(upsellC));
        return hasMain && hasUpsell;
      });
    }

    if (!variant) {
      // Debug utilissimo: mostra cosa stai cercando e cosa esiste davvero
      console.debug('[UPSELL DEBUG] trying match', {
        bundleHandle: bundleHandle,
        raw: {
          mainColorRaw: mainColorRaw,
          upsellColorRaw: upsellColorRaw,
          mainColorOriginalRaw: mainColorOriginalRaw,
          upsellOriginalRaw: upsellOriginalRaw
        },
        canonical: {
          mainColor: mainColor,
          upsellColor: upsellColor,
          mainColor_clean: mainC,
          upsellColor_clean: upsellC
        }
      });

      console.debug(
        '[UPSELL DEBUG] bundle variants (cleaned)',
        (product.variants || []).map(function (v) {
          return {
            id: v.id,
            option1: v.option1,
            option2: v.option2,
            o1: clean(v.option1),
            o2: clean(v.option2),
            title: v.title,
            t: clean(v.title)
          };
        })
      );

      throw new Error(
        'Variante non trovata per (canonico): ' +
          mainColor +
          ' + ' +
          upsellColor +
          ' | (raw): ' +
          mainColorRaw +
          ' + ' +
          upsellColorRaw
      );
    }

    return variant.id;
  }

  // =========================================================================
  // Rimozione prodotto principale dal carrello (by variant_id)
  // =========================================================================
  async function removeVariantFromCart(variantId) {
    var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!cartRes.ok) throw new Error('cart.js non disponibile');
    var cartData = await cartRes.json();

    // Shopify /cart/change.js usa "line" 1-based
    var idx = (cartData.items || []).findIndex(function (i) {
      return String(i.variant_id) === String(variantId);
    });
    var line = idx >= 0 ? idx + 1 : 0;
    if (!line) throw new Error('Prodotto principale non trovato nel carrello (variant_id=' + variantId + ')');

    var changeRes = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
    if (!changeRes.ok) throw new Error('change.js status ' + changeRes.status);
  }

  // =========================================================================
  // Aggiunta bundle (by variant id)
  // =========================================================================
  async function addBundleToCart(bundleVariantId) {
    var addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: bundleVariantId, quantity: 1 })
    });
    if (!addRes.ok) throw new Error('add.js status ' + addRes.status);
  }

  // =========================================================================
  // Eventi (delegation su body)
  // =========================================================================
  function bindEventsOnce() {
    if (document.body.dataset.upsellBound === '1') return;
    document.body.dataset.upsellBound = '1';

    // Aggiunta bundle (sostituisce il prodotto principale)
    document.body.addEventListener('click', async function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('.upsell-add-button') : null;
      if (!btn) return;

      event.preventDefault();

      var card = btn.closest ? btn.closest('.cart-drawer-upsell-product') : null;
      if (!card || !card.dataset) {
        console.error('[UPSELL] Card upsell non trovata o senza dataset');
        return;
      }

      var bundleHandle = card.dataset.bundleHandle;
      var mainColorRaw = card.dataset.mainColor || '';
      var mainColorOriginalRaw = card.dataset.mainColorOriginal || '';

      var selectEl = card.querySelector ? card.querySelector('select.upsell-variant-select') : null;
      var sel = getSelectedOption(selectEl);
      var upsellColorRaw = sel.text;
      var upsellOriginalRaw = sel.dataOriginal;
      if (!upsellColorRaw && card.dataset) {
        upsellColorRaw = card.dataset.upsellVariantTitle || '';
        upsellOriginalRaw = card.dataset.upsellVariantOriginal || '';
      }

      if (!bundleHandle) {
        console.error('[UPSELL] Dati insufficienti: manca bundleHandle');
        return;
      }

      var currentVid = (btn.dataset && btn.dataset.currentVariantId) ? btn.dataset.currentVariantId : null;
      if (!currentVid) {
        console.error('[UPSELL] Missing current variant ID');
        return;
      }

      // 1) Trova la variante bundle corretta tramite mappa colori + matching robusto
      var bundleVid;
      try {
        bundleVid = await getBundleVariantId(
          bundleHandle,
          mainColorRaw,
          upsellColorRaw,
          mainColorOriginalRaw,
          upsellOriginalRaw
        );
      } catch (e) {
        console.error('[UPSELL] Errore recupero variante bundle:', e);
        return;
      }

      // 2) Rimuove il prodotto principale
      try {
        await removeVariantFromCart(currentVid);
      } catch (e) {
        console.error('[UPSELL] Errore rimozione prodotto principale:', e);
        return;
      }

      // 3) Aggiunge il bundle
      try {
        await addBundleToCart(bundleVid);
        refreshCartDrawer();
      } catch (e) {
        console.error('[UPSELL] Errore aggiunta bundle:', e);
      }
    });

    // Chiudi/ignora upsell
    document.body.addEventListener('click', function (event) {
      var removeBtn = event.target && event.target.closest ? event.target.closest('.cart-drawer__upsell--remove') : null;
      if (!removeBtn) return;

      event.preventDefault();

      var upsellCard = removeBtn.closest ? removeBtn.closest('.cart-drawer-upsell-product') : null;
      if (upsellCard) upsellCard.style.display = 'none';
    });
  }

  // =========================================================================
  // Boot
  // =========================================================================
  document.addEventListener('DOMContentLoaded', function () {
    // bind una sola volta anche se il drawer viene ricaricato via AJAX
    bindEventsOnce();

    // opzionale: preload color map per evitare una fetch "a sorpresa" al click
    // (non blocca nulla se fallisce)
    loadColorMap().catch(function () {});
  });
})();
